// src\stores\reducers\todos.ts
// import { RESIZE } from './../../constants';
// import { IMobile } from '../types';



// const device = (state: IMobile = {isM: false, is750: false, is1440: false, is1200: false, is1920: true}, action: { type: string; value: any }) => {
//   switch (action.type) {
//     case RESIZE:
//       return  {
//         ...state,
//         ...action.value
//       };
//     default:
//       return state;
//   }
// };

// export default device;
import { createSlice } from '@reduxjs/toolkit';
import { IMobile } from '../types';

const initialState: IMobile = {
  isM: false,
  is750: false,
  is1440: false,
  is1200: false,
  is1920: true
};

const deviceSlice = createSlice({
  name: 'device',
  initialState,
  reducers: {
    resize: (state, action) => {
      return {
        ...state,
        ...action.payload
      };
    }
  }
});

export const { resize } = deviceSlice.actions;
export default deviceSlice;